<template>
  <v-card v-if="vehicle">
    <v-btn color="grey" small class="tariff-left-headers">
      <h3>{{ $i18n.t("Permits") }}</h3>
    </v-btn>
    <z-expense-create
      color="blue"
      style="float: right;"
      x-small
      :accountCode="'VehicleExpense'"
      :entity_id="vehicle._id"
      :expenseType="'Permits'"
      @reload="reloadInsurExpenses"
      btn
    >
      <v-btn color="cyan" x-small class="tariff-right-headers">
      +  {{ $i18n.t("Add") }}
      </v-btn>
    </z-expense-create>
    <!-- <v-btn
      color="blue"
      style="float: right"
      x-small
      class="tariff-right-headers"
      target="_blank"
      :href="
        '/expense/create?accountCode=VehicleExpense&expenseType=Permits&vehicle_id=' +
        vehicle._id
      "
      >+ {{ $i18n.t("Add") }}</v-btn
    > -->

    <expenses :expenseType="'Permits'" :entity_id="vehicle._id" />
  </v-card>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
// import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import Expenses from "@/views/vehicle/Expenses.vue";

@Component({
  name: "Permit",
  props: {
    value: {
      default: null,
    },
  },
  components: {
    Expenses,
  },
})
export default class Permit extends Vue {
  vehicle = null;

  get loading() {
    return common.loading;
  }

  async mounted() {
    if (this.value) this.vehicle = this.value;

    if (!this.vehicle) this.vehicle = {};
    if (!this.vehicle.vehicleDetail) this.vehicle.vehicleDetail = {};
  }

  @Watch("value")
  onValueChange(newVal) {
    this.vehicle = newVal;
  }

  formatDate(date) {
    if (date) {
      const dateStr = date.toString();
      return (
        dateStr.substring(6, 8) +
        "-" +
        dateStr.substring(4, 6) +
        "-" +
        dateStr.substring(0, 4)
      );
    } else {
      return "";
    }
  }

  reloadInsurExpenses() {
    this.$root.$emit('reloadExpenses', true);
    // this.$emit("reload", true);
  }
}
</script>

<style scoped>
.tariff-left-headers {
  text-transform: none;
  color: #555;
  top: -10px;
  left: 10px;
  right: 0px;
  font-size: 12px;
}
.tariff-right-headers {
  text-transform: none;
  color: #555;
  top: -10px;
  right: 10px;
  font-size: 12px;
}
.close-button {
  text-transform: none;
  color: rgb(255, 66, 66);
  bottom: 7px;
  /* top: -10px; */
  right: 0px;
  font-size: 12px;
  position: absolute;
  z-index: 100;
}
.tab-pane {
  display: none;
}
</style>